import React from 'react';

const ZipDJIcon = ({ iconType }) => {
  const className = `zd-icon zd-icon-${iconType}`;
  return (
    <i className={className}></i>
  );
};
export default ZipDJIcon;
